import { useId, useRef } from "react";
import { MAX_BUBBLE_TEXT_LENGTH } from "../../comic/comicTypes";
import { useDialogFocus } from "../useDialogFocus";

interface BubbleTextDialogProps {
  text: string;
  onChange: (text: string) => void;
  onCancel: () => void;
  onConfirm: () => void;
}

export function BubbleTextDialog({ text, onChange, onCancel, onConfirm }: BubbleTextDialogProps) {
  const textareaRef = useRef<HTMLTextAreaElement>(null);
  const dialogRef = useRef<HTMLElement>(null);
  const countId = useId();
  useDialogFocus(dialogRef, textareaRef, onCancel);
  return (
    <div className="dialog-backdrop" role="presentation" onMouseDown={onCancel}>
      <section
        aria-describedby={countId}
        aria-labelledby="bubble-text-title"
        aria-modal="true"
        className="comic-dialog"
        onMouseDown={(event) => event.stopPropagation()}
        ref={dialogRef}
        role="dialog"
      >
        <p className="eyebrow">Dialogue</p>
        <h2 id="bubble-text-title">What should it say?</h2>
        <label htmlFor="bubble-text">Bubble text</label>
        <textarea
          aria-describedby={countId}
          id="bubble-text"
          maxLength={MAX_BUBBLE_TEXT_LENGTH}
          onChange={(event) => onChange(event.target.value)}
          ref={textareaRef}
          rows={6}
          value={text}
        />
        <p id={countId}>
          {text.length}/{MAX_BUBBLE_TEXT_LENGTH} characters
        </p>
        <div className="comic-dialog__actions">
          <button className="button button--secondary" onClick={onCancel} type="button">
            Cancel
          </button>
          <button className="button button--primary" onClick={onConfirm} type="button">
            Use this text
          </button>
        </div>
      </section>
    </div>
  );
}
